import { WATERMARK } from "constants/chartCommons";
import { LD6Chart, OptionsScatterSeries } from "store/slice/charts/chartsSlice.types";

export const RADIUS = 8;

export const getOption = (
    callbacks: {
        onClose: () => void;
        load: Highcharts.ChartLoadCallbackFunction;
        legendItemClick: Highcharts.SeriesLegendItemClickCallbackFunction;
        onPointClick: Highcharts.PointClickCallbackFunction;
    },
    chartData: LD6Chart
): OptionsScatterSeries => ({
    chart: {
        animation: false,
        className: "PotentialChart",
        type: "scatter",
        events: {
            click: callbacks.onClose,
        },
    },
    credits: {
        text: WATERMARK,
        href: "#",
        position: {
            align: "left",
        },
        style: {
            fontSize: "8px",
        },
    },
    title: {
        text: undefined,
    },
    legend: {
        verticalAlign: "bottom",
        itemWidth: 120,
        margin: 20,
    },
    tooltip: {
        enabled: true,
        backgroundColor: "black",
        borderWidth: 0,
        borderRadius: 2,
        useHTML: true,
        shadow: false,
        padding: 2,
        style: {
            color: "white",
            fontSize: "11px",
        },
        formatter: function (this: Highcharts.TooltipFormatterContextObject) {
            return `<div>
                <span>${chartData?.yAxis?.title?.text}: </span>${this.y}<br />
                <span>${chartData?.xAxis?.title?.text}: </span>${this.x}
            </div>`;
        },
    },
    xAxis: {
        ...chartData.xAxis,
        startOnTick: false,
        endOnTick: false,
        lineWidth: 0,
        tickColor: "transparent",
        gridLineColor: "transparent",
        title: { text: undefined },
        labels: {
            enabled: false,
        },
        plotLines: [
            {
                value: 50,
                color: "#84acbc",
                width: 1,
            },
        ],
    },
    yAxis: {
        ...chartData.yAxis,
        startOnTick: false,
        endOnTick: false,
        lineWidth: 0,
        tickColor: "transparent",
        gridLineColor: "transparent",
        title: { text: undefined },
        labels: {
            enabled: false,
        },
        plotLines: [
            {
                value: 50,
                color: "#84acbc",
                width: 1,
            },
        ],
    },
    plotOptions: {
        series: {
            animation: false,
            marker: {
                radius: RADIUS,
            },
            dataLabels: {
                enabled: true,
                y: 13,
                x: 8,
                align: "left",
                useHTML: true,
                padding: 5,
                style: {
                    fontWeight: "normal",
                    fontSize: "13px",
                    color: "#515151",
                },
            },
            stickyTracking: false,
            events: {
                legendItemClick: callbacks.legendItemClick,
            },
            point: {
                events: {
                    click: callbacks.onPointClick,
                },
            },
        },
    },
    exporting: {
        menuItemDefinitions: {
            downloadPNG: { text: "Download PNG Image" },
            downloadSVG: { text: "Download SVG Image" },
        },
        buttons: {
            contextButton: {
                menuItems: ["downloadPNG", "downloadSVG"],
            },
        },
        chartOptions: {
            chart: {
                events: {
                    load: callbacks.load,
                },
            },
        },
    },
});
